import { render } from "./KomisionetView.vue?vue&type=template&id=69717ba2&scoped=true"
import script from "./KomisionetView.vue?vue&type=script&lang=js"
export * from "./KomisionetView.vue?vue&type=script&lang=js"

import "./KomisionetView.vue?vue&type=style&index=0&id=69717ba2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69717ba2"]])

export default __exports__